import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import CenteredSpinner from './CenteredSpinner';
import ScrollToTop from 'react-scroll-to-top';
import { PropertyCard } from './PropertyCard';
import { Home } from 'react-feather';

export const MyDraftListings = () => {
  const queryClient = useQueryClient();
  const [search, setSearch] = useState('');
  const [userId] = useState(localStorage.getItem('userId'));
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [propertyID, setPropertyID] = useState('');
  const [propertyRef, setPropertyRef] = useState(null);
  const [properties, setProperties] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [userID] = useState(localStorage.getItem('userId'));
  const navigate = useNavigate();


  useEffect(() => {
    document.title = 'Favourites';
    window.scrollTo(0, 0);
  }, []);

  const fetchDraftListings = () => {
    const options = {
      method: 'GET',
      url: `/Property/GetDraftProperties/${localStorage.getItem('staffMemberId')}/false`,
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error('Server error');
      });
  };

  const {
    isLoading,
    isError,
    error,
    data: favouritesData,
  } = useQuery(['Drafts'], fetchDraftListings);


  const filterFavouriteData = (favouritesDatafilter, search) => {
    if (!search) {
      return favouritesDatafilter;
    }

    return favouritesDatafilter.filter((data) => {
      return (
        data?.propertyTypeName
          .replace(/,/g, '')
          .toLowerCase()
          .includes(search.replace(/,/g, '').toLowerCase()) ||
        data?.localityName
          .replace(/,/g, '')
          .toLowerCase()
          .includes(search.replace(/,/g, '').toLowerCase()) ||
        data?.propertyStateName
          .replace(/,/g, '')
          .toLowerCase()
          .includes(search.replace(/,/g, '').toLowerCase()) ||
        data?.propertyRef.includes(search)
      );
    });
  };

  const filterFavouriteDatas = filterFavouriteData(
    favouritesData,
    search,
  );

  if (isLoading) {
    return <CenteredSpinner />;
  }

  if (isError || error) {
    return (
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <h1>Server is down, please try again later </h1>
        </div>
      </div>
    );
  }

  const totalDrafts = filterFavouriteDatas?.length ?? 0;

  return (
    <div className="container pt-3 pb-4">
      <ScrollToTop smooth color="#6f00ff" />
      <div className="card shadow-sm border-0 overflow-hidden property-list-card">
        <div className="property-list-hero d-flex align-items-center px-4 py-3">
          <div className="property-list-hero-icon d-flex align-items-center justify-content-center">
            <Home size={20} />
          </div>
          <div className="ml-3">
            <p className="mb-1 text-uppercase text-white-50 small">Draft Listings</p>
            <h4 className="mb-0 text-white">Properties waiting for completion.</h4>
          </div>
          <button
            type="button"
            className="btn btn-light btn-sm ml-auto property-list-back"
            onClick={() => navigate(-1)}
          >
            <i className="fas fa-arrow-left me-2"></i>
            Back
          </button>
        </div>

        <div className="p-4">
          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="property-list-count">{totalDrafts}</div>
              <div className="ml-3">
                <p className="mb-1 text-muted small">Draft properties</p>
                <h5 className="mb-0">Review and complete your drafts.</h5>
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 col-md-7 mb-3">
              <div className="form-group has-search w-100 property-list-search">
                <span className="fa fa-search form-control-feedback"></span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>

          {totalDrafts < 1 ? (
            <h5 className="text-center text-muted">No search results found</h5>
          ) : null}

          <div className="row mb-4">
            {filterFavouriteDatas &&
              React.Children.toArray(
                filterFavouriteDatas?.map((property, index) => (
                  <PropertyCard
                    property={property}
                    index={index}
                    location={location}
                    showRemoveFavouriteBtn={false}
                    showHotBtn={false}
                  />
                )),
              )}
          </div>
        </div>
      </div>
    </div>
  );
};
